/* ============================================================
   KZ Location Info — geolocation-based shipping line.
   Resolves the visitor's city/region via 4-tier fallback:
     1. wtfismyip.com (MaxMind-backed; most accurate for BR IPs we tested,
                       beats ipinfo/ipapi which often misroute CGNAT'd IPs
                       to the SP datacenter that hosts the carrier)
     2. ipapi.co      (free, 30k req/month, HTTPS, no key — region_code abbr)
     3. ipinfo.io     (free, 50k req/month, HTTPS, no key — full region name)
     4. browser geolocation + BigDataCloud reverse geocode
   24h localStorage cache. 3s per-request timeout.
   ============================================================ */
(function () {
  'use strict';

  var CACHE_TTL_MS = 86400000; // 24h
  var REQUEST_TIMEOUT_MS = 3000;

  var STORAGE_KEYS = {
    location: 'kz_userLocation_v3',
    timestamp: 'kz_locationTimestamp_v3'
  };

  var ENDPOINTS = {
    wtfismyip: 'https://wtfismyip.com/json',
    ipapi: 'https://ipapi.co/json/',
    ipinfo: 'https://ipinfo.io/json',
    bigDataCloud: 'https://api.bigdatacloud.net/data/reverse-geocode-client'
  };

  var addressEl = document.getElementById('loc-address');
  var translations = window.locTranslations || {};

  function readCache() {
    try {
      var loc = localStorage.getItem(STORAGE_KEYS.location);
      var ts = localStorage.getItem(STORAGE_KEYS.timestamp);
      if (!loc || !ts) return null;
      if (Date.now() - parseInt(ts, 10) > CACHE_TTL_MS) return null;
      return loc;
    } catch (_e) {
      return null;
    }
  }

  function writeCache(location) {
    try {
      localStorage.setItem(STORAGE_KEYS.location, location);
      localStorage.setItem(STORAGE_KEYS.timestamp, String(Date.now()));
    } catch (_e) {
      /* private mode / quota — silently skip */
    }
  }

  function fetchJSON(url) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT_MS);
    return fetch(url, {
      signal: controller.signal,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .finally(function () { clearTimeout(timer); });
  }

  function tryWtfIsMyIp() {
    return fetchJSON(ENDPOINTS.wtfismyip).then(function (data) {
      // Returns "City, Region/State, Country" — split, take first 2.
      if (data && data.YourFuckingLocation) {
        var parts = data.YourFuckingLocation.split(',').map(function (p) { return p.trim(); });
        if (parts[0] && parts[1]) return parts[0] + ', ' + parts[1];
      }
      return null;
    });
  }

  function tryIpApi() {
    return fetchJSON(ENDPOINTS.ipapi).then(function (data) {
      // Prefer region_code (e.g. "RS") over region (e.g. "Rio Grande do Sul")
      // for cleaner display.
      if (data && data.city && (data.region_code || data.region)) {
        return data.city + ', ' + (data.region_code || data.region);
      }
      return null;
    });
  }

  function tryIpInfo() {
    return fetchJSON(ENDPOINTS.ipinfo).then(function (data) {
      if (data && data.city && data.region) return data.city + ', ' + data.region;
      return null;
    });
  }

  function getCurrentPosition() {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false,
        timeout: REQUEST_TIMEOUT_MS,
        maximumAge: 0
      });
    });
  }

  function tryBrowserGeolocation() {
    if (!navigator.geolocation) return Promise.resolve(null);
    return getCurrentPosition().then(function (position) {
      var url = ENDPOINTS.bigDataCloud +
        '?latitude=' + encodeURIComponent(position.coords.latitude) +
        '&longitude=' + encodeURIComponent(position.coords.longitude) +
        '&localityLanguage=pt';
      return fetchJSON(url);
    }).then(function (data) {
      if (data && data.city && data.principalSubdivision) {
        return data.city + ', ' + data.principalSubdivision;
      }
      return null;
    });
  }

  function fetchLocation() {
    var sources = [tryWtfIsMyIp, tryIpApi, tryIpInfo, tryBrowserGeolocation];
    var i = 0;
    function next() {
      if (i >= sources.length) {
        displayError();
        return;
      }
      sources[i++]()
        .then(function (location) {
          if (location) {
            writeCache(location);
            displayLocation(location);
          } else {
            next();
          }
        })
        .catch(function (e) {
          console.warn('[location-info] source failed:', e && e.message);
          next();
        });
    }
    next();
  }

  /**
   * Build "<strong>Frete Grátis</strong> para <strong>Porto Alegre e RS</strong>"
   * via DOM nodes — never innerHTML, since `loc` is fetched from external APIs.
   */
  function displayLocation(loc) {
    if (!addressEl) return;
    var parts = loc.split(', ').slice(0, 2);
    var formatted = parts.join(' ' + (translations.and || 'e') + ' ');

    addressEl.replaceChildren();

    var freeShippingStrong = document.createElement('strong');
    freeShippingStrong.textContent = translations.free_shipping || '';

    var locationStrong = document.createElement('strong');
    locationStrong.textContent = formatted;

    addressEl.append(
      freeShippingStrong,
      ' ' + (translations.to_location || '') + ' ',
      locationStrong
    );
    addressEl.classList.remove('loading');
  }

  function displayError() {
    if (!addressEl) return;
    addressEl.textContent = translations.error_message || '';
    addressEl.classList.remove('loading');
  }

  function init() {
    if (!addressEl) return;
    var cached = readCache();
    if (cached) {
      displayLocation(cached);
      return;
    }
    fetchLocation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
